/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2022-10-13
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-13
 */

(() => {
	const MIN_WIDTH = 360;

	const vp = document.querySelector('meta[name="viewport"]');
	function fn() {
		const v = window.outerWidth > MIN_WIDTH ? 'width=device-width,initial-scale=1' : `width=${MIN_WIDTH}`;
		if (vp.getAttribute('content') !== v) {
			vp.setAttribute('content', v);
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();

/**
 * Back To Top
 *
 * @author Takuto Yanagida
 * @version 2022-10-13
 */

(() => {
	function init() {
		const OFFSET_Y = 0;

		const btn = document.getElementById('back-to-top');
		if (btn === null) return;
		const ph  = btn.parentElement;

		onScroll(scrollHandler);
		onResize(scrollHandler);
		if ('ontouchstart' in window) window.addEventListener('touchmove', scrollHandler);
		setTimeout(scrollHandler, 100);

		function scrollHandler() {
			const viewBottomY = window.innerHeight + OFFSET_Y/* - btnH*/;
			const footerTopY = ph.getBoundingClientRect().top;

			if (viewBottomY > footerTopY) {
				btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
				btn.classList.remove('fixed');
			} else {
				btn.style.transform = '';
				btn.classList.add('fixed');
			}

			if (window.pageYOffset > window.innerHeight / 3) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

	const resizeListeners = [];
	const scrollListeners = [];

	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}

	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});

	init();
})();

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2022-07-11
 */

 document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.stile *[class^="button"]');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		return f.classList.contains('frame') || f.classList.contains('frame-alt');
	}

	function setEventListener(btn) {
		btn.classList.add('toggle');
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		f.style.display = 'none';
		f.classList.add('hidden');
		setTimeout(() => { f.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		if (visible) {
			f.classList.remove('hidden');
		} else {
			f.classList.add('hidden');
		}
	}

});


/**
 * Header Navigation Misc.
 *
 * @author Space-Time Inc.
 * @version 2022-09-26
 */

document.addEventListener('DOMContentLoaded', () => {
	const btn = document.querySelector('#menu-button-search');
	if (!btn) return;

	const panel = document.querySelector('#panel-search');
	if (!panel) return;

	btn.addEventListener('click', () => {
		btn.parentElement.classList.toggle('open');
		panel.classList.toggle('open');
	});
});

/**
 * Hamburger Menu
 *
 * @author Space-Time Inc.
 * @version 2022-10-13
 */

/**
 * Modal History
 *
 * @author Space-Time Inc.
 * @version 2022-10-03
 */

class ModalHistory {

	#iDs        = null;
	#hashPrefix = null;
	#doOpen     = () => {};
	#doClose    = () => {};
	#curId      = null;

	constructor(iDs, hashPrefix, doOpen, doClose) {
		this.#iDs        = iDs;
		this.#hashPrefix = hashPrefix;
		this.#doOpen     = doOpen;
		this.#doClose    = doClose;

		window.addEventListener('popstate', e => this.#onPopState(e));
		window.addEventListener('hashchange', () => this.#onHashChange());
		this.#onHashChange();
	}

	#callOpenHandler(id) {
		const oldId = this.#curId;
		this.#curId = id;
		this.#doOpen(this.#curId, oldId);
	}

	#callCloseHandler(id) {
		this.#curId = null;
		this.#doClose(id);
	}

	#onPopState(e) {
		if (this.#curId !== null && this.#iDs.has(this.#curId)) {
			this.#callCloseHandler(this.#curId);
		}
		if (e?.state?.name === 'model-history' && this.#iDs.has(e?.state?.id ?? '')) {
			this.#callOpenHandler(e.state['id']);
		}
	}

	#onHashChange() {
		const hash = location.hash;
		if (hash.indexOf(`#${this.#hashPrefix}`) !== 0) return;

		const id = hash.replace(`#${this.#hashPrefix}`, '');
		if (!id || !this.#iDs.has(id)) return;

		if (this.#curId !== null && this.#curId !== id) {
			this.#callCloseHandler(id);
		}
		if (this.#curId === null || this.#curId !== id) {
			this.#callOpenHandler(id);
		}
	}

	start(id) {
		if (location.hash) {
			const href = location.href;
			const url  = href.substring(0, href.indexOf('#'));
			history.replaceState(null, '', url);
		}
		history.pushState({ name: 'model-history', id }, null, `#${this.#hashPrefix}${id}`);
		this.#callOpenHandler(id);
	}

	move(id) {
		history.replaceState(null, '', `#${this.#hashPrefix}${id}`);
		this.#callOpenHandler(id);
	}

	end() {
		history.back();
		this.#callCloseHandler(this.#curId);
	}

}


document.addEventListener('DOMContentLoaded', () => {
	if (!document.body.classList.contains('page-template-front-page')) {
		initHamburgerMenu();
	}

	function initHamburgerMenu() {
		const mpMenu = document.querySelector('.modal-panel.menu');

		let curPanel = null;

		const iDs = new Set(['menu']);
		const mh  = new ModalHistory(iDs, '', doOpen, doClose);

		initPanel(mpMenu, mh);

		const menuBtn = document.querySelector('.site-header .menu-button');
		menuBtn.addEventListener('click', () => mh.start('menu'));

		function doOpen(id, oldId) {
			document.body.classList.add('modal');
			if ('menu' === id) {
				mpMenu.classList.add('open');
				curPanel = mpMenu;
				menuBtn.classList.add('open');
			}
		}

		function doClose() {
			curPanel.classList.remove('open');
			document.body.classList.remove('modal');
			curPanel = null;
			menuBtn.classList.remove('open');
		}
	}

	function initPanel(panel, mh) {
		const btnClose = panel.querySelector('button');
		btnClose.addEventListener('click', () => mh.end());
	}
});


/**
 * Assigning Entry Image Top
 *
 * @author Space-Time Inc.
 * @version 2022-10-28
 */

(() => {
	const sh = document.querySelector('.site-header');
	const ei = document.querySelector('.entry-image');
	const ef = document.querySelector('.entry-frame');

	if (!sh || !ei || !ef) return;

	function fnResize() {
		const bcr1 = sh.getBoundingClientRect();
		ei.style.top = `${bcr1.height}px`;
	}
	addEventListener('resize', throttle(fnResize), false);
	fnResize();

	function fnScroll() {
		const bcr1 = ef.getBoundingClientRect();
		const bcr2 = ei.getBoundingClientRect();
		if (bcr1.y < bcr2.y + bcr2.height * 0.5) {
			ei.classList.add('filter');
		} else {
			ei.classList.remove('filter');
		}
	}
	addEventListener('scroll', throttle(fnScroll), false);
	fnScroll();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();

